export default __webpack_public_path__ + "static/media/firstArti.f58e39de.png";